import Shimmer from "react-shimmer-effect";
import styled from "styled-components";
import React from 'react';

const Line = styled.div`
  width: ${({ width }) => width ? width : '100%'};
  height: 10px;
  border-radius: 10px;
  border-radius: 8px;
  margin-bottom: 10px;  
  `;
const shimmer = (props) => (
  <>
    <div style={{
      backgroundColor: 'white', marginBottom: '70px', marginTop: '20px',
      border: "0px solid rgba(255, 255, 255, 1)",
      borderRadius: "4px",
      backgroundColor: "white",
      display: "flex",
      padding: "16px",
      width: "100%",
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Shimmer>
        <Line key='line1' />
        <Line key='line2' width='60%' />
        <Line key='line3' width='75%' />
      </Shimmer>
    </div>
    {[1, 2, 3, 4].map((val, index) => {
      return <div key={index} style={{
        backgroundColor: 'white', marginBottom: '10px', marginTop: '10px',
        border: "0px solid rgba(255, 255, 255, 1)",
        borderRadius: "4px",
        backgroundColor: "white",
        display: "flex",
        padding: "16px",
        width: "100%"
      }}>
        <Shimmer>
          <Line key='line1' />
        </Shimmer>
      </div>
    })
    }
  </>
)

export default shimmer;